import { useState, type MouseEvent, type MouseEventHandler } from "react";

import ListMenu, { type ListMenuItem } from "@rio-cloud/rio-uikit/ListMenu";
import BranchesPage from "./pages/BranchesPage";
import SegmentsPage from "./pages/SegmentsPage";
import SupplierPage from "./pages/SupplierPage";
import VendorsPage from "./pages/VendorPage";
import CategoriesPage from "./pages/CategoriesPage";
import SubCategoriesPage from "./pages/SubCategoriesPage";
import PaymentMethodsPage from "./pages/PaymentMethodsPage";
import AuditPage from "./pages/AuditPage";
import { useT } from "@hooks";

const ABAS = [
  "branches",
  "segments",
  "customers",
  "suppliers",
  "categories",
  "subcategories",
  "paymentMethods",
  "audit",
];

const menuItems = (
  activeItem: string,
  onItemClick: MouseEventHandler<HTMLButtonElement>,
  t: (id: string) => string
): ListMenuItem[] => [
  {
    group: t("settings.menu.group"),
    navItems: ABAS.map((aba, indice) => ({
      key: aba,
      item: (
        <button
          type="button"
          className={activeItem === String(indice) ? "active" : ""}
          data-key={String(indice)}
          onClick={onItemClick}
        >
          {t(`settings.menu.${aba}`)}
        </button>
      ),
    })),
  },
];

const SettingsPage = () => {
  const [activeItem, setActiveItem] = useState("0");
  const t = useT();

  const onItemClick = (event: MouseEvent<HTMLButtonElement>) => {
    setActiveItem(event.currentTarget.dataset.key as string);
  };

  return (
    <div className="display-flex flex-column flex-row-sm justify-content-start height-auto height-100pct-sm">
      <div className="margin-10 margin-0-sm width-300-sm flex-0 bg-lightest padding-top-10 padding-top-25-sm height-auto height-100pct-sm">
        <div className="margin-top-10">
          <ListMenu menuItems={menuItems(activeItem, onItemClick, t)} />
        </div>
      </div>
      <div className="padding-10 padding-25-sm flex-1-1 min-width-0">
        {activeItem === "0" && <BranchesPage />}
        {activeItem === "1" && <SegmentsPage />}
        {activeItem === "2" && <SupplierPage />}
        {activeItem === "3" && <VendorsPage />}
        {activeItem === "4" && <CategoriesPage />}
        {activeItem === "5" && <SubCategoriesPage />}
        {activeItem === "6" && <PaymentMethodsPage />}
        {activeItem === "7" && <AuditPage />}
      </div>
    </div>
  );
};

export default SettingsPage;
